export const removeCountryAndKindCodes = (patentNumber: string): string => {
  if (!patentNumber) return '';

  // Remove country code prefix (e.g., US, EP, WO)
  let cleaned = patentNumber.replace(/^[A-Z]{2}/i, '');

  // Remove kind code suffix (e.g., A1, B2)
  cleaned = cleaned.replace(/[A-Z]\d*$/i, '');

  // Remove any remaining non-digit characters
  cleaned = cleaned.replace(/[^\d]/g, '');

  return cleaned;
};
